import { SearchDashboard, SAPTransactionRes } from '@/models/saptransactions.model'
import { VEClient } from '@/utils/axios'

export const postDashboard = async (data: SearchDashboard): Promise<SAPTransactionRes> => {
  const response = await VEClient.post(`/api/sap/dashboard`, data)
  return response.data
}